import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';

import { Layout } from './components/Layout';
import { lazyPage } from './lib/lazy-page';
import { CamerasPage } from './pages/CamerasPage';
import { CameraDetectionsPage } from './pages/CameraDetectionsPage';
import { CategoryPage } from './pages/CategoryPage';
import { NowPage } from './pages/NowPage';
import { SaunasPage } from './pages/SaunasPage';
import { SourcesPage } from './pages/SourcesPage';
import { TmsPage } from './pages/TmsPage';

// MapLibre GL JS on raskas (~1,3 MB) → ladataan vain kun karttasivu avataan.
//
// lazyPage (eikä paljas lazy): deployn jälkeen käyttäjän selaimessa voi olla
// vanha index.html, jonka chunk-nimiä ei enää ole olemassa. Silloin import
// kaatuu ("error loading dynamically imported module") ja lazyPage lataa sivun
// kerran uudelleen — ks. lib/chunk-reload.ts.
const MapPage = lazyPage(
  () => import('./pages/MapPage').then((module) => ({ default: module.MapPage })),
  'Kartta',
);
const NysseMapPage = lazyPage(
  () => import('./pages/NysseMapPage').then((module) => ({ default: module.NysseMapPage })),
  'Nysse',
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

function NotFound() {
  return (
    <section className="page">
      <h1 className="page__title">Sivua ei löytynyt</h1>
      <p className="page__lead">
        <Link to="/">Palaa tilannekuvaan</Link>
      </p>
    </section>
  );
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<NowPage />} />
            <Route
              path="kartta"
              element={
                <Suspense fallback={<p className="state state--loading">Ladataan karttaa…</p>}>
                  <MapPage />
                </Suspense>
              }
            />
            <Route path="liikenne" element={<CategoryPage category="TRAFFIC" />} />
            <Route
              path="nysse-kartta"
              element={
                <Suspense fallback={<p className="state state--loading">Ladataan karttaa…</p>}>
                  <NysseMapPage />
                </Suspense>
              }
            />
            <Route path="kamerat" element={<CamerasPage />} />
            <Route path="kamerahavainnot" element={<CameraDetectionsPage />} />
            <Route path="liikennemaarat" element={<TmsPage />} />
            <Route path="saunat" element={<SaunasPage />} />
            <Route path="saa" element={<CategoryPage category="WEATHER" />} />
            <Route path="poliisi" element={<CategoryPage category="POLICE" />} />
            <Route path="joukkoliikenne" element={<CategoryPage category="PUBLIC_TRANSPORT" />} />
            <Route path="lahteet" element={<SourcesPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
